module.exports = __webpack_public_path__ + "static/media/test17_2.d1aa990b.png";